import { transformAsCurrency, formatCurrencyAsTex3 } from '~/utils/functions';
import { DecomposicaoData } from '../types';

export const calculaTotalQtd = (data: DecomposicaoData[]): number => {
  const result = data.reduce((total, item) => total + item.qtd_decomp, 0);
  const resultFormated = formatCurrencyAsTex3(result);
  return transformAsCurrency(resultFormated);
};
